<template>
  <div>
    <div style="margin-bottom: 32px; margin-top: -8px">
      <div class="content-input">
        <div class="content-input-item">
          <label>关键词：</label>
          <el-select v-model="blockContent" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in blockContentArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <el-button type="primary" @click="getPage"> 查询 </el-button>
        </div>
      </div>
    </div>
    <div>
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          style="width: 100%"
          border
          @cell-click="toggleSelection"
          v-loading="listLoading"
          @sort-change="sortChange"
      >
        <el-table-column label="头像">
          <template #default="scope">
            <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </template>
        </el-table-column>
        <el-table-column label="用户信息" width="240">
          <template #default="scope">
            <UserInfoList :row="scope.row" showList="name,phone,uid,city,birth" :isDialog="true"/>
          </template>
        </el-table-column>
        <el-table-column property="msgTime" label="最新纸条时间" sortable='custom'/>
        <el-table-column property="msgNum" label="纸条对话数量" class-name="cursor" sortable='custom'>
          <template #default="scope">
            <span style="color: #409eff">{{ scope.row.msgNum}}</span>
          </template>
        </el-table-column>
        <el-table-column property="msgViolationNum" label="违规纸条对话数量" sortable='custom' class-name="cursor">
          <template #default="scope">
            <span v-if="scope.row.msgViolationNum > 0" style="color: red;">{{scope.row.msgViolationNum}}</span>
          </template>
        </el-table-column>
        <el-table-column property="" label="状态">
          <template #default="scope">
            <p v-if="scope.row.screenState == 1" style="color: red">已屏蔽</p>
            <p v-if="scope.row.isBannedChat" style="color: red">已禁言</p>
            <p v-if="scope.row.isForbidden" style="color: red">已封号</p>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../../../components/DatePickerRange'
import SearchComponents from '../../../../components/SearchComponents'
import {getMsgUserPageList, getUserChatResume} from '@/api/url'
import { getFormData } from '@/api/api'
import UserLogDialog from '../../../../components/UserLog/UserLogDialog'
import Dialog from '../../../../assets/js/dialog'
import ImgViewer from '../../../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import MsgUserContentList from './MsgUserContentList'
import UserInfoList from "@/components/resume/UserInfoList";

export default {
  name: "InviteDetailDialog",
  components: { DatePickerRange, SearchComponents, UserInfoList },
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.id,
      violationState: this.value.violationState,

      sort: 1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      blockContentArray: this.value.blockContentArray,
      blockContent: '',

      //搜索
      searchType: '',
      searchValue: '',

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //排序
    sortChange(column) {
      if(column.prop == 'msgTime') {
        if(column.order == 'descending') {
          this.sort = 1;
        } else if(column.order == 'ascending') {
          this.sort = 2;
        }
      } else if(column.prop == 'msgNum') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      } else if(column.prop == 'msgViolationNum') {
        if(column.order == 'descending') {
          this.sort = 5;
        } else if(column.order == 'ascending') {
          this.sort = 6;
        }
      }
      this.getPage();
    },

    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.userId;
      param['sort'] = this.sort;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['violationState'] = this.violationState;
      param['blockContent'] = this.blockContent;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getMsgUserPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {

      // //更新用户日志
      // if(column.label == '用户日志') {
      //   Dialog.open({
      //     title: '用户日志',
      //     component: UserLogDialog,
      //     data: {
      //       id: row.userId
      //     },
      //     close: () => {
      //       row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
      //     }
      //   })
      // }

      //纸条对话数量
      if(column.label == '纸条对话数量') {
        let param = {};
        param['userId'] = this.userId;
        param['toUserId'] = row.userId;
        getFormData(getUserChatResume, param).then((data) => {
          let {msg, code } = data;
          if(code == 200) {
            let resumeInfo = data['data'];
            Dialog.open({
              title: '纸条对话列表',
              component: MsgUserContentList,
              data: {
                userId: this.userId,
                toUserId: row.userId,
                resumeInfo: resumeInfo,
                state: -1,
                blockContentArray: this.blockContentArray,
                width: '1100px'
              },
              close: () => {

              }
            })
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
        })
      }

      //纸条对话数量
      if(column.label == '违规纸条对话数量') {
        let param = {};
        param['userId'] = this.userId;
        param['toUserId'] = row.userId;
        getFormData(getUserChatResume, param).then((data) => {
          let {msg, code } = data;
          if(code == 200) {
            let resumeInfo = data['data'];
            Dialog.open({
              title: '违规纸条对话数量',
              component: MsgUserContentList,
              data: {
                userId: this.userId,
                toUserId: row.userId,
                resumeInfo: resumeInfo,
                state: 1,
                blockContentArray: this.blockContentArray,
                width: '1100px'
              },
              close: () => {

              }
            })
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
        })
      }


    },


  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
